export * from './meta';

export const lazy = () => import('./page');
